import { SiteLocale } from 'apps/website/types/dato';

interface Translation {
  [SiteLocale.FR]: TranslationString;
  [SiteLocale.EN]: TranslationString;
  [SiteLocale.ES]: TranslationString;
  [SiteLocale.DE]: undefined;
}

type TranslationString = {
  'aria.minus': string;
  'aria.plus': string;
  'aria.numberEmployeesInput': string;
  'aria.numberEmployeesInput.plural': string;
  'aria.numberEmployeesInput.max': string;
  'aria.numberEmployeesInput.min': string;
  'aria.numberEmployeesInput.max.disabled': string;
  'aria.numberEmployeesInput.min.disabled': string;
  'aria.firstPayroll.disabled': string;
  'aria.firstPayroll.enabled': string;
  'aria.firstPayroll.action': string;
  'aria.numberEmployeesInput.action': string;
  'features.plan.prefix': string;
  'features.plan.suffix': string;
  'features.plan.default': string;
};

export const translation: Translation = {
  fr: {
    'aria.minus': 'Diminuer le nombre de collaborateurs',
    'aria.plus': 'Augmenter le nombre de collaborateurs',
    'aria.numberEmployeesInput':
      'Vous avez sélectionné [nbEmployee] collaborateur',
    'aria.numberEmployeesInput.plural':
      'Vous avez sélectionné [nbEmployee] collaborateurs',
    'aria.numberEmployeesInput.max': 'Augmenter le nombre de collaborateurs',
    'aria.numberEmployeesInput.max.disabled':
      'Vous avez atteint le nombre maximum de collaborateurs',
    'aria.numberEmployeesInput.min': 'Diminuer le nombre de collaborateurs',
    'aria.numberEmployeesInput.min.disabled':
      'Vous avez atteint le nombre minimum de collaborateurs',
    'aria.firstPayroll.disabled': "Vous n'afficher plus l'offre firstPayroll",
    'aria.firstPayroll.enabled': "Vous afficher l'offre firstPayroll",
    'aria.firstPayroll.action': "Afficher l'offre firstPayroll",
    'aria.numberEmployeesInput.action': 'Modifier le nombre de collaborateurs',
    'features.plan.prefix': 'Tout',
    'features.plan.suffix': 'plus :',
    'features.plan.default': 'Ce plan inclut :',
  },
  en: {
    'aria.minus': 'Decrease the number of collaborators',
    'aria.plus': 'Increase the number of collaborators',
    'aria.numberEmployeesInput': 'You have selected [nbEmployee] collaborator',
    'aria.numberEmployeesInput.plural':
      'You have selected [nbEmployee] collaborators',
    'aria.numberEmployeesInput.max': 'Increase the number of collaborators',
    'aria.numberEmployeesInput.max.disabled':
      'You have reached the maximum number of collaborators',
    'aria.numberEmployeesInput.min': 'Decrease the number of collaborators',
    'aria.numberEmployeesInput.min.disabled':
      'You have reached the minimum number of collaborators',
    'aria.firstPayroll.disabled': 'You do not display the firstPayroll offer',
    'aria.firstPayroll.enabled': 'You display the firstPayroll offer',
    'aria.firstPayroll.action': 'Display the firstPayroll offer',
    'aria.numberEmployeesInput.action': 'Modify the number of collaborators',
    'features.plan.prefix': 'All',
    'features.plan.suffix': 'plus:',
    'features.plan.default': 'This plan includes :',
  },
  es: {
    'aria.minus': 'Disminuir el número de colaboradores',
    'aria.plus': 'Aumentar el número de colaboradores',
    'aria.numberEmployeesInput': 'Has seleccionado [nbEmployee] colaborador',
    'aria.numberEmployeesInput.plural':
      'Has seleccionado [nbEmployee] colaboradores',
    'aria.numberEmployeesInput.max': 'Aumentar el número de colaboradores',
    'aria.numberEmployeesInput.max.disabled':
      'Has alcanzado el máximo número de colaboradores',
    'aria.numberEmployeesInput.min': 'Disminuir el número de colaboradores',
    'aria.numberEmployeesInput.min.disabled':
      'Has alcanzado el mínimo número de colaboradores',
    'aria.firstPayroll.disabled': 'No estás mostrando la oferta firstPayroll',
    'aria.firstPayroll.enabled': 'Estás mostrando la oferta firstPayroll',
    'aria.firstPayroll.action': 'Mostrar la oferta firstPayroll',
    'aria.numberEmployeesInput.action': 'Modificar el número de colaboradores',
    'features.plan.prefix': 'Todo',
    'features.plan.suffix': 'mas :',
    'features.plan.default': 'Este plan incluye :',
  },
  de: undefined,
};
